import React from 'react';
import styles from './CardDate.module.scss';

const CardDate = ({ children }) => {
  return <div className={styles.root}>{children}</div>;
};

export default CardDate;
